import React from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';
import theme from 'shared/styles/theme';

import Renderer, { RendererProps } from './Renderer';
import { VXLComponentId, VXLGroupId } from './types';

/**
 * some components layout edge to edge. this set contains the names of those
 * so we can quickly check if a component should be rendered with padding or not.
 */
const edgeToEdgeUISet = new Set<string | number>([
  VXLComponentId.LIST_ITEM,
  VXLComponentId.DISCOVER_MORE_SECTION,
  VXLComponentId.MARKETING_CARD_CAROUSEL,
  VXLGroupId.LIST_ITEM_GROUP,
  VXLGroupId.SCROLLING_BUTTON_GROUP,
]);

export interface RendererWithHorizontalPaddingProps extends RendererProps {
  paddingHorizontal: keyof typeof theme.spacing;
}

/**
 * this renderer adds the provided horizontal padding value to all components
 * it renders unless they are 'edge to edge' components.
 */
const RendererWithHorizontalPadding = (
  props: RendererWithHorizontalPaddingProps,
) => {
  const { toRender, paddingHorizontal } = props;
  // if VXLNode is "child" ie. has a name, and that name is not set to
  // layout edge to edge, then add padding.

  if (
    toRender &&
    (('name' in toRender && !edgeToEdgeUISet.has(toRender.name)) ||
      !('name' in toRender))
  ) {
    return (
      <View style={styles[paddingHorizontal]}>
        <Renderer {...props} />
      </View>
    );
  }
  return <Renderer {...props} />;
};

/* eslint-disable react-native/no-unused-styles -- dynamic style keys require disabling the rule */
const styles: Record<keyof typeof theme.spacing, ViewStyle> = StyleSheet.create(
  {
    l: { paddingHorizontal: theme.spacing.l },
    m: { paddingHorizontal: theme.spacing.m },
    s: { paddingHorizontal: theme.spacing.s },
    xl: { paddingHorizontal: theme.spacing.xl },
    xs: { paddingHorizontal: theme.spacing.xs },
    xxl: { paddingHorizontal: theme.spacing.xxl },
  },
);
/* eslint-enable react-native/no-unused-styles */

export default RendererWithHorizontalPadding;
